import { createFileRoute } from "@tanstack/react-router";
import { InstrumentsPage } from "@/features/experiments/instruments-page";
import { uploadSearch } from "@/lib/upload-route";

export const Route = createFileRoute("/instruments/")({
  validateSearch: uploadSearch,
  component: Page,
});
function Page() {
  return <InstrumentsPage />;
}
